import type { ReactNode } from 'react';

export interface SectionHeaderProps {
  /** Visible label, will be rendered uppercase. */
  readonly children: ReactNode;
  readonly className?: string;
  /** Optional content rendered flush-right (e.g. a "See all" link). */
  readonly trailing?: ReactNode;
}

/**
 * Uppercase micro-label used above lists and groups.
 * 10px / 1.4px letter-spacing / weight 600 / text-tertiary.
 *
 * The single "terminal" character signature in the visual language —
 * keep it consistently spaced with `padding-left: 2px` so it aligns
 * with surface-card content padding.
 */
export function SectionHeader({ children, className = '', trailing }: SectionHeaderProps) {
  return (
    <div
      className={[
        'flex items-center justify-between pl-0.5 text-[10px] font-semibold uppercase tracking-[1.4px] text-text-tertiary',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span>{children}</span>
      {trailing}
    </div>
  );
}
